import ClassChallengeIcon from './component.jsx'
export default ClassChallengeIcon
